import { get } from '@alltrails/core/utils/get';
import type { UserId } from '@alltrails/types/User';
import type { BelayUserConnection, ConnectionPageResponse } from '@alltrails/types/belay';

export const getReviewsConnections = (userIds: UserId[], userId?: number) =>
  get<ConnectionPageResponse>(`/api/alltrails/connect/users/${userId}/connections?filter[userIds]=${userIds}&limit=${userIds?.length}`);

export const getUserConnectionStatus = (userId: number, otherUserId: number) =>
  get<BelayUserConnection>(`/api/alltrails/connect/users/${userId}/connections/${otherUserId}`);
